import { Button, ButtonProps } from "antd";
import React from "react";

const CancelButton: React.FC<ButtonProps> = ({ onClick,title="Cancel", ...rest }) => {
  return (
    <Button htmlType="button" className="cancelBtn" onClick={onClick} {...rest}>
      {title}
    </Button>
  );
};

export default CancelButton;
